

export const Product = () => {
    return (
        <div className="product-container"></div>
    )
}